module.exports = ({
    'SM810H005': 'Information',
    'SM810OTP001': 'Don’t show this dialog again',
})